import type {KeyValue} from '@jetbrains/teamcity-ui/dist/utils'

import type {SuggestionType} from '../../types'

import type {
  PipelineDraftState,
  PipelineFormsState,
  PipelineDebugState,
  PipelineYamlDraftState,
  PipelineYamlValidityState,
  PipelineDependencyDetailsState,
} from './EditPipelinePage.slices.types'

export const initialState: PipelineDraftState = {}

export const collapsedBlocksInitialState: Record<string, boolean> = {}

export const pipelineFormInitialState: PipelineFormsState = {}

export const pipelineYamlInitialState: PipelineYamlDraftState = {}
export const pipelineYamlValidityState: PipelineYamlValidityState = {}

export const MIN_PARALLELISM_COUNT = 2

export const suggestionsInitialState: {
  skippedSuggestions: Record<string, string[]>
  successMessages: Record<string, SuggestionType | null>
} = {
  skippedSuggestions: {},
  successMessages: {},
}

export const debugInitialState: PipelineDebugState = {}

export const pipelineDependencyDetailsInitialState: PipelineDependencyDetailsState = {}

export const pipelineKotlinDslInitialState: KeyValue<string, {dslCode?: string; error?: string}> =
  {}
